/** Round to 2 decimal places, away from zero (sign preserved). */
export function round2AwayFromZero(x: number): number {
  if (!Number.isFinite(x)) return 0;
  const s = Math.sign(x);
  return s * Math.round(Math.abs(x) * 100) / 100;
}

/** `x` is a fraction in [0, 1]; e.g. 0.6525 → "65.25%". */
export function formatPct2(x: number): string {
  if (!Number.isFinite(x)) return '0.00%';
  return `${(x * 100).toFixed(2)}%`;
}

export function formatCurrencyCompact(x: number, currency = 'USD'): string {
  if (!Number.isFinite(x)) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(x);
}
